"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _tokens = require("../../styles/tokens");
var _makeStylesInternal = _interopRequireDefault(require("../../makeStyles/makeStylesInternal"));
// Styles only to be used for the RichTextEditor (base, Quill styles)
// Style should only target QuillJS focused elements

/**
 * Quill Editor v1.3.7 - Snow css converted to JSS
 * https://quilljs.com/
 **/
var editorStyles = (0, _makeStylesInternal.default)(function (theme) {
  return {
    root: {
      '& .ql-container.ql-disabled .ql-tooltip': {
        visibility: 'hidden'
      },
      '& .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before': {
        pointerEvents: 'none'
      },
      '& .ql-clipboard': {
        left: '-100000px',
        height: '1px',
        overflowY: 'hidden',
        position: 'absolute',
        top: '50%'
      },
      '& .ql-clipboard p': {
        margin: '0',
        padding: '0'
      },
      // repeated in renderer
      '& .ql-editor': {
        backgroundColor: theme.palette.grey[100],
        fontFamily: _tokens.fontFamilyDefault,
        fontSize: _tokens.fontSizeDefault,
        boxSizing: 'border-box',
        lineHeight: '1.42',
        height: '100%',
        outline: 'none',
        overflowY: 'auto',
        padding: _tokens.spacing50,
        tabSize: '1.5rem',
        mozTabSize: '1.5rem',
        textAlign: 'left',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        borderRadius: "0 0 " + _tokens.borderRadiusSmall + " " + _tokens.borderRadiusSmall
      },
      '& .ql-editor > *': {
        cursor: 'text'
      },
      '& .ql-snow.ql-toolbar:after, .ql-snow .ql-toolbar:after': {
        clear: 'both',
        content: '\'\'',
        display: 'table'
      },
      '& .ql-snow.ql-toolbar button, .ql-snow .ql-toolbar button': {
        background: 'none',
        fill: theme.palette.grey[500],
        border: 'none',
        cursor: 'pointer',
        display: 'inline-block',
        float: 'left',
        height: _tokens.sizingLarge,
        width: _tokens.sizingLarge,
        padding: '.375rem .375rem',
        borderRadius: _tokens.borderRadiusXSmall,
        lineHeight: 0,
        '&:hover': {
          backgroundColor: theme.palette.grey[250]
        },
        '&:active': {
          backgroundColor: theme.palette.grey[300]
        }
      },
      '& .ql-snow.ql-toolbar button.ql-active, .ql-snow .ql-toolbar button': {
        backgroundColor: theme.palette.grey[300],
        '&:hover': {
          backgroundColor: theme.palette.grey[300]
        }
      },
      '& .ql-snow.ql-toolbar button svg, .ql-snow .ql-toolbar button svg': {
        height: '70%',
        width: '70%',
        color: theme.palette.grey[500],
        fill: theme.palette.grey[500]
      },
      '& .ql-snow.ql-toolbar button:active:hover, .ql-snow .ql-toolbar button:active:hover': {
        outline: 'none'
      },
      '& .ql-snow.ql-toolbar input.ql-image[type=file], .ql-snow .ql-toolbar input.ql-image[type=file]': {
        display: 'none'
      },
      '& .ql-snow.ql-toolbar .ql-picker .ql-picker-label.ql-active': {
        backgroundColor: theme.palette.grey[100]
      },
      '& .ql-snow.ql-toolbar .ql-picker-item': {
        '&:not(:first-child):not(:last-child)': {
          borderRadius: 'unset !important'
        },
        '&:first-child': {
          borderRadius: _tokens.borderRadiusSmall + " " + _tokens.borderRadiusSmall + " 0 0"
        },
        '&:last-child': {
          borderRadius: "0 0 " + _tokens.borderRadiusSmall + " " + _tokens.borderRadiusSmall
        }
      },
      '& .ql-snow.ql-toolbar .ql-picker-item.ql-selected': {
        backgroundColor: theme.palette.action.base,
        color: theme.palette.grey[100],
        '&:hover': {
          backgroundColor: theme.palette.action.hover
        }
      },
      '& .ql-snow.ql-toolbar .ql-picker-item:hover': {
        backgroundColor: theme.palette.grey[250]
      },
      '& .ql-snow.ql-toolbar .ql-picker-item:active': {
        backgroundColor: theme.palette.action.active,
        color: theme.palette.grey[100],
        outline: 'none',
        boxShadow: 'none !important'
      },
      '& .ql-snow .ql-picker-options .ql-picker-item:focus': {
        borderRadius: _tokens.borderRadiusSmall,
        boxShadow: _tokens.boxShadowFocusInset,
        outline: 'none'
      },
      '& .ql-snow.ql-toolbar button:hover, .ql-snow .ql-toolbar button:hover, .ql-snow.ql-toolbar button.ql-active, .ql-snow .ql-toolbar button.ql-active, .ql-snow.ql-toolbar .ql-picker-label:hover, .ql-snow .ql-toolbar .ql-picker-label:hover, .ql-snow.ql-toolbar .ql-picker-label.ql-active, .ql-snow .ql-toolbar .ql-picker-label.ql-active': {
        borderRadius: _tokens.borderRadiusSmall
      },
      '& .ql-snow.ql-toolbar button:focus, .ql-snow .ql-toolbar button:focus, .ql-snow.ql-toolbar .ql-picker-label:focus': {
        borderRadius: _tokens.borderRadiusSmall,
        boxShadow: _tokens.boxShadowFocusInset,
        outline: 'none'
      },
      '& .ql-snow.ql-toolbar button:hover .ql-fill, .ql-snow .ql-toolbar button:hover .ql-fill, .ql-snow.ql-toolbar button:focus .ql-fill, .ql-snow .ql-toolbar button:focus .ql-fill, .ql-snow.ql-toolbar button.ql-active .ql-fill, .ql-snow .ql-toolbar button.ql-active .ql-fill, .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill, .ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill, .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill, .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill, .ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill, .ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill, .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill, .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill, .ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill, .ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill, .ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill, .ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill, .ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill, .ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill, .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill, .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill, .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill, .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill, .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill, .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill, .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill, .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill': {
        fill: theme.palette.grey[500]
      },
      '& .ql-snow.ql-toolbar button:hover .ql-stroke, .ql-snow .ql-toolbar button:hover .ql-stroke, .ql-snow.ql-toolbar button:focus .ql-stroke, .ql-snow .ql-toolbar button:focus .ql-stroke, .ql-snow.ql-toolbar button.ql-active .ql-stroke, .ql-snow .ql-toolbar button.ql-active .ql-stroke, .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke, .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke, .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke, .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke, .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke, .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke, .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke, .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke, .ql-snow.ql-toolbar button:hover .ql-stroke-miter, .ql-snow .ql-toolbar button:hover .ql-stroke-miter, .ql-snow.ql-toolbar button:focus .ql-stroke-miter, .ql-snow .ql-toolbar button:focus .ql-stroke-miter, .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter, .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter, .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter, .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter, .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter, .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter, .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter, .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter, .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter, .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter': {
        stroke: theme.palette.grey[500]
      },
      '@media (pointer: coarse)': {
        '& .ql-snow.ql-toolbar button:hover:not(.ql-active), .ql-snow .ql-toolbar button:hover:not(.ql-active)': {
          color: '#444'
        },
        '& .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill, .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill, .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill, .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill': {
          fill: theme.palette.grey[500]
        },
        '& .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke, .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke, .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter, .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter': {
          stroke: theme.palette.grey[500]
        }
      },
      '& .ql-snow': {
        boxSizing: 'border-box'
      },
      '& .ql-snow *': {
        boxSizing: 'border-box'
      },
      '& .ql-snow .ql-hidden': {
        display: 'none'
      },
      '& .ql-snow .ql-out-bottom, .ql-snow .ql-out-top': {
        visibility: 'hidden'
      },
      '& .ql-snow .ql-tooltip': {
        position: 'absolute',
        transform: 'translateY(10px)',
        backgroundColor: '#fff',
        display: 'none',
        border: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        boxShadow: '0px 0px 5px #ddd',
        color: '#444',
        padding: '5px 12px',
        whiteSpace: 'nowrap'
      },
      '& .ql-snow .ql-tooltip a': {
        cursor: 'pointer',
        textDecoration: 'none',
        lineHeight: '26px'
      },
      '& .ql-snow .ql-tooltip.ql-flip': {
        transform: 'translateY(-10px)'
      },
      '& .ql-snow .ql-formats': {
        display: 'inline-block',
        verticalAlign: 'middle',
        padding: "0px " + _tokens.spacing20,
        '&:first-child': {
          padding: "0px " + _tokens.spacing20 + " 0px 0px"
        },
        '&:last-child': {
          padding: "0px 0px 0px " + _tokens.spacing20
        }
      },
      '& .ql-snow .ql-formats:after': {
        clear: 'both',
        content: '\'\'',
        display: 'table'
      },
      '& span.ql-formats + span.ql-formats': {
        borderLeft: _tokens.borderWidthThin + " solid " + theme.palette.grey[300]
      },
      '& .ql-snow .ql-stroke': {
        fill: 'none',
        stroke: '#444',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '2'
      },
      '& .ql-snow .ql-stroke-miter': {
        fill: 'none',
        stroke: '#444',
        strokeMiterlimit: '10',
        strokeWidth: '2'
      },
      '& .ql-snow .ql-fill, .ql-snow .ql-stroke.ql-fill': {
        fill: '#444'
      },
      '& .ql-snow .ql-empty': {
        fill: 'none'
      },
      '& .ql-snow .ql-even': {
        fillRule: 'evenodd'
      },
      '& .ql-snow .ql-thin, .ql-snow .ql-stroke.ql-thin': {
        strokeWidth: '1'
      },
      '& .ql-snow .ql-transparent': {
        opacity: '0.4'
      },
      // Text direction toolbar button
      '& .ql-snow .ql-direction span:last-child': {
        display: 'none'
      },
      '& .ql-snow .ql-direction.ql-active span:last-child': {
        display: 'inline'
      },
      '& .ql-snow .ql-direction.ql-active span:first-child': {
        display: 'none'
      },
      '& .ql-snow .ql-picker': {
        color: theme.palette.grey[500],
        fill: theme.palette.grey[500],
        backgroundColor: theme.palette.grey[100],
        display: 'inline-block',
        float: 'left',
        fontSize: '14px',
        height: '32px',
        position: 'relative',
        verticalAlign: 'middle',
        fontFamily: _tokens.fontFamilyDefault,
        fontWeight: _tokens.fontWeightNormal,
        borderRadius: _tokens.borderRadiusSmall
      },
      '& .ql-snow .ql-color-picker': {
        backgroundColor: 'transparent'
      },
      '& .ql-snow .ql-picker-label': {
        cursor: 'pointer',
        display: 'inline-block',
        height: '100%',
        paddingLeft: '8px',
        paddingRight: '2px',
        position: 'relative',
        width: '100%',
        borderRadius: _tokens.borderRadiusSmall
      },
      '& .ql-snow .ql-picker-label::before': {
        display: 'inline-block',
        lineHeight: '22px'
      },
      '& .ql-snow .ql-picker-options': {
        backgroundColor: '#fff',
        display: 'none',
        minWidth: '100%',
        position: 'absolute',
        whiteSpace: 'nowrap'
      },
      '& .ql-snow .ql-picker-options .ql-picker-item': {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'left',
        // assigning this to 'left' will automatically flip to 'right' when rtl is on via JSS
        padding: _tokens.spacing30 + " " + _tokens.spacing40,
        borderBottom: _tokens.borderWidthThin + " solid " + theme.palette.grey[250],
        color: theme.palette.grey[600]
      },
      '& .ql-snow .ql-picker-options .ql-picker-item:last-child': {
        borderBottom: 'none'
      },
      '& .ql-snow .ql-picker.ql-expanded .ql-picker-label': {
        color: '#ccc',
        zIndex: _tokens.zIndexDropdown + 1
      },
      '& .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill': {
        fill: theme.palette.grey[500]
      },
      '& .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke': {
        stroke: theme.palette.grey[500]
      },
      '& .ql-snow .ql-picker.ql-expanded .ql-picker-options': {
        display: 'block',
        marginTop: '-1px',
        top: '100%',
        zIndex: _tokens.zIndexDropdown
      },
      '& .ql-snow .ql-color-picker, .ql-snow .ql-icon-picker': {
        width: '32px'
      },
      '& .ql-snow .ql-color-picker .ql-picker-label, .ql-snow .ql-icon-picker .ql-picker-label': {
        padding: '0px',
        justifyContent: 'center'
      },
      '& .ql-snow .ql-color-picker .ql-picker-label svg, .ql-snow .ql-icon-picker .ql-picker-label svg': {
        right: '4px'
      },
      '& .ql-snow .ql-icon-picker .ql-picker-options': {
        padding: '4px 0px'
      },
      '& .ql-snow .ql-icon-picker .ql-picker-item': {
        height: '24px',
        width: '24px',
        padding: '2px 4px'
      },
      '& .ql-snow .ql-color-picker .ql-picker-options': {
        padding: _tokens.spacing20 + " 0.313rem",
        width: '4.938rem',
        borderRadius: _tokens.borderRadiusMedium
      },
      '& .ql-snow .ql-color-picker .ql-picker-item': {
        border: 'none',
        float: 'left',
        height: '1.125rem',
        margin: _tokens.spacing10,
        padding: '0px',
        width: '1.125rem',
        borderRadius: _tokens.borderRadiusXSmall,
        '&:hover': {
          outline: "0.125rem solid " + theme.palette.grey[300]
        },
        '&:focus': {
          boxShadow: "0px 0px 0px 2px " + _tokens.fountain600,
          outline: ' none'
        }
      },
      '& .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg': {
        position: 'absolute',
        marginTop: '-9px',
        right: '0',
        top: '50%',
        width: '18px'
      },
      '& .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=\'\'])::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=\'\'])::before, .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=\'\'])::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=\'\'])::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=\'\'])::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=\'\'])::before': {
        content: 'attr(data-label)'
      },
      '& .ql-snow .ql-picker.ql-font': {
        width: '108px'
      },
      '& .ql-snow .ql-picker.ql-font .ql-picker-label::before, .ql-snow .ql-picker.ql-font .ql-picker-item::before': {
        content: '\'Sans Serif\''
      },
      '& .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before': {
        content: '\'Serif\''
      },
      '& .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before': {
        content: '\'Monospace\''
      },
      '& .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before': {
        fontFamily: 'Georgia, Times New Roman, serif'
      },
      '& .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before': {
        fontFamily: 'Monaco, Courier New, monospace'
      },
      '& .ql-snow .ql-picker.ql-size': {
        width: '98px'
      },
      '& .ql-snow .ql-picker.ql-size .ql-picker-label::before, .ql-snow .ql-picker.ql-size .ql-picker-item::before': {
        content: '\'Normal\''
      },
      '& .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before': {
        content: '\'Small\''
      },
      '& .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before': {
        content: '\'Large\''
      },
      '& .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before': {
        content: '\'Huge\''
      },
      '& .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before': {
        fontSize: '10px'
      },
      '& .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before': {
        fontSize: '18px'
      },
      '& .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before': {
        fontSize: '32px'
      },
      '& .ql-snow .ql-color-picker.ql-background .ql-picker-item': {
        backgroundColor: '#fff'
      },
      '& .ql-snow .ql-color-picker.ql-color .ql-picker-item': {
        backgroundColor: '#000'
      },
      '& .ql-toolbar.ql-snow': {
        backgroundColor: theme.palette.grey[100],
        border: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        borderRadius: _tokens.borderRadiusSmall + " " + _tokens.borderRadiusSmall + " 0 0",
        boxSizing: 'border-box',
        fontFamily: '\'Helvetica Neue\', \'Helvetica\', \'Arial\', sans-serif',
        padding: '8px'
      },
      '& .ql-toolbar.ql-snow .ql-picker-label': {
        textAlign: 'left',
        // assigning this to 'left' will automatically flip to 'right' when rtl is on via JSS
        display: 'flex',
        alignItems: 'center',
        lineHeight: 0
      },
      '& .ql-toolbar.ql-snow .ql-picker-options': {
        border: _tokens.borderWidthThin + " solid transparent",
        boxShadow: 'rgba(0,0,0,0.2) 0 2px 8px'
      },
      '& .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label': {
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.grey[600]
      },
      '& .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options': {
        marginTop: "" + _tokens.spacing20,
        border: 'none',
        borderRadius: "" + _tokens.borderRadiusSmall,
        filter: 'drop-shadow(0px 4px 4px rgba(0,0,0,20%))'
      },
      '& .ql-toolbar.ql-snow .ql-formats .ql-color-picker.ql-expanded .ql-picker-options': {
        width: '78px',
        height: '56px',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        padding: "" + _tokens.spacing20,
        alignContent: 'flex-end'
      },
      '& .ql-toolbar.ql-snow + .ql-container.ql-snow': {
        borderTop: '0px'
      },
      '& .ql-snow .ql-tooltip::before': {
        content: '"Visit URL:"',
        lineHeight: '26px',
        marginRight: '8px'
      },
      '& .ql-snow .ql-tooltip input[type=text]': {
        display: 'none',
        border: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        fontSize: '13px',
        height: '26px',
        margin: '0px',
        padding: '3px 5px',
        width: '170px'
      },
      '& .ql-snow .ql-tooltip a.ql-preview': {
        display: 'inline-block',
        maxWidth: '200px',
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        verticalAlign: 'top'
      },
      '& .ql-snow .ql-tooltip a.ql-action::after': {
        borderRight: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        content: '\'Edit\'',
        marginLeft: '16px',
        paddingRight: '8px'
      },
      '& .ql-snow .ql-tooltip a.ql-remove::before': {
        content: '\'Remove\'',
        marginLeft: '8px'
      },
      '& .ql-snow .ql-tooltip.ql-editing a.ql-preview, .ql-snow .ql-tooltip.ql-editing a.ql-remove': {
        display: 'none'
      },
      '& .ql-snow .ql-tooltip.ql-editing input[type=text]': {
        display: 'inline-block'
      },
      '& .ql-snow .ql-tooltip.ql-editing a.ql-action::after': {
        borderRight: '0px',
        content: '\'Save\'',
        paddingRight: '0px'
      },
      '& .ql-snow .ql-tooltip[data-mode=link]::before': {
        content: '"Enter link:"'
      },
      '& .ql-snow .ql-tooltip[data-mode=formula]::before': {
        content: '"Enter formula:"'
      },
      '& .ql-snow .ql-tooltip[data-mode=video]::before': {
        content: '"Enter video:"'
      },
      '& .ql-container.ql-snow': {
        border: _tokens.borderWidthThin + " solid " + theme.palette.grey[300],
        borderRadius: "0 0 " + _tokens.borderRadiusSmall + " " + _tokens.borderRadiusSmall
      },
      // Header and Body format dropdown - toolbar labels and styles
      '& .ql-snow .ql-picker.ql-header': {
        width: '98px',
        '& .ql-picker-item[data-value="1"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader1,
          fontWeight: _tokens.fontWeightBold
        },
        '& .ql-picker-item[data-value="2"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader2,
          fontWeight: _tokens.fontWeightBold
        },
        '& .ql-picker-item[data-value="3"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader3,
          fontWeight: _tokens.fontWeightBold
        },
        '& .ql-picker-item[data-value="4"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader4,
          fontWeight: _tokens.fontWeightBold
        },
        '& .ql-picker-item[data-value="5"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader5,
          fontWeight: _tokens.fontWeightBold
        },
        '& .ql-picker-item[data-value="6"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader6,
          fontWeight: _tokens.fontWeightBold
        },
        // Custom Toolbar - Custom Header toolbar dropdown item label styles
        '& .ql-picker-item[data-value="h1"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader1,
          fontWeight: _tokens.fontWeightBold
        },
        '& .ql-picker-item[data-value="h2"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader2,
          fontWeight: _tokens.fontWeightBold
        },
        '& .ql-picker-item[data-value="h3"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader3,
          fontWeight: _tokens.fontWeightBold
        },
        '& .ql-picker-item[data-value="h4"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader4,
          fontWeight: _tokens.fontWeightBold
        },
        '& .ql-picker-item[data-value="h5"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader5,
          fontWeight: _tokens.fontWeightBold
        },
        '& .ql-picker-item[data-value="h6"]::before': {
          fontFamily: _tokens.fontFamilyHeader,
          fontSize: _tokens.fontSizeHeader6,
          fontWeight: _tokens.fontWeightBold
        },
        '& .ql-picker-item[data-value="body1"]::before': {
          fontFamily: _tokens.fontFamilyDefault,
          fontSize: _tokens.fontSizeLarge,
          fontWeight: _tokens.fontWeightNormal
        },
        '& .ql-picker-item[data-value="body2"]::before': {
          fontFamily: _tokens.fontFamilyDefault,
          fontSize: _tokens.fontSizeDefault,
          fontWeight: _tokens.fontWeightNormal
        },
        '& .ql-picker-item[data-value="body3"]::before': {
          fontFamily: _tokens.fontFamilyDefault,
          fontSize: _tokens.fontSizeSmall,
          fontWeight: _tokens.fontWeightNormal
        },
        '& .ql-picker-item[data-value="caption"]::before': {
          fontFamily: _tokens.fontFamilyCondensed,
          fontSize: _tokens.fontSizeDefault,
          fontWeight: _tokens.fontWeightNormal,
          letterSpacing: '0.0625rem',
          textTransform: 'uppercase'
        }
      }
    },
    rtl: {
      // Custom RTL Styles
      '&.ql-snow-rtl': {
        '& .ql-picker': {
          float: 'right'
        },
        '& .ql-editor ol, .ql-editor ul': {
          paddingRight: '1.5em !important'
        },
        '& .ql-editor ': {
          flip: false,
          textAlign: 'left' //permits left text-alignment when the RTE direction button is present
        }
      }
    },
    translations: {
      /**
       * eee-dashboard uses the same method of translations
       */
      // Default Locale translations
      // Start en_US translations
      '&.ql-locale-en-US': {
        '& .ql-snow': {
          '& .ql-picker.ql-header': {
            // Default Quill Toolbar - Header toolbar dropdown item labels
            '& .ql-picker-label::before, & .ql-picker-item::before': {
              content: '"Normal"'
            },
            // Custom Toolbar - Custom Header toolbar dropdown item labels
            '& .ql-picker-label[data-value="h1"]::before, & .ql-picker-item[data-value="h1"]::before': {
              content: '"Header 1"'
            },
            '& .ql-picker-label[data-value="h2"]::before, & .ql-picker-item[data-value="h2"]::before': {
              content: '"Header 2"'
            },
            '& .ql-picker-label[data-value="h3"]::before, & .ql-picker-item[data-value="h3"]::before': {
              content: '"Header 3"'
            },
            '& .ql-picker-label[data-value="h4"]::before, & .ql-picker-item[data-value="h4"]::before': {
              content: '"Header 4"'
            },
            '& .ql-picker-label[data-value="h5"]::before, & .ql-picker-item[data-value="h5"]::before': {
              content: '"Header 5"'
            },
            '& .ql-picker-label[data-value="h6"]::before, & .ql-picker-item[data-value="h6"]::before': {
              content: '"Header 6"'
            },
            '& .ql-picker-label[data-value="body1"]::before, & .ql-picker-item[data-value="body1"]::before': {
              content: '"Body 1"'
            },
            '& .ql-picker-label[data-value="body2"]::before, & .ql-picker-item[data-value="body2"]::before': {
              content: '"Body 2"'
            },
            '& .ql-picker-label[data-value="body3"]::before, & .ql-picker-item[data-value="body3"]::before': {
              content: '"Body 3"'
            },
            '& .ql-picker-label[data-value="caption"]::before, & .ql-picker-item[data-value="caption"]::before': {
              content: '"Caption"'
            }
          }
        }
      },
      // Start en_AU translations
      '&.ql-locale-en-AU': {
        '& .ql-snow': {
          '& .ql-picker.ql-header': {
            // Default Quill Toolbar - Header toolbar dropdown item labels
            '& .ql-picker-label::before, & .ql-picker-item::before': {
              // Normal
              content: '"Normal"'
            },
            // Custom Toolbar - Custom Header toolbar dropdown item labels
            '& .ql-picker-label[data-value="h1"]::before, & .ql-picker-item[data-value="h1"]::before': {
              // Header 1
              content: '"Header 1"'
            },
            '& .ql-picker-label[data-value="h2"]::before, & .ql-picker-item[data-value="h2"]::before': {
              // Header 2
              content: '"Header 2"'
            },
            '& .ql-picker-label[data-value="h3"]::before, & .ql-picker-item[data-value="h3"]::before': {
              // Header 3
              content: '"Header 3"'
            },
            '& .ql-picker-label[data-value="h4"]::before, & .ql-picker-item[data-value="h4"]::before': {
              // Header 4
              content: '"Header 4"'
            },
            '& .ql-picker-label[data-value="h5"]::before, & .ql-picker-item[data-value="h5"]::before': {
              // Header 5
              content: '"Header 5"'
            },
            '& .ql-picker-label[data-value="h6"]::before, & .ql-picker-item[data-value="h6"]::before': {
              // Header 6
              content: '"Header 6"'
            },
            '& .ql-picker-label[data-value="body1"]::before, & .ql-picker-item[data-value="body1"]::before': {
              // Body 1
              content: '"Body 1"'
            },
            '& .ql-picker-label[data-value="body2"]::before, & .ql-picker-item[data-value="body2"]::before': {
              // Body 2
              content: '"Body 2"'
            },
            '& .ql-picker-label[data-value="body3"]::before, & .ql-picker-item[data-value="body3"]::before': {
              // Body 3
              content: '"Body 3"'
            },
            '& .ql-picker-label[data-value="caption"]::before, & .ql-picker-item[data-value="caption"]::before': {
              // Caption
              content: '"Caption"'
            }
          }
        }
      },
      // End en_AU translations
      // Start en_GB translations
      '&.ql-locale-en-GB': {
        '& .ql-snow': {
          '& .ql-picker.ql-header': {
            // Default Quill Toolbar - Header toolbar dropdown item labels
            '& .ql-picker-label::before, & .ql-picker-item::before': {
              // Normal
              content: '"Normal"'
            },
            // Custom Toolbar - Custom Header toolbar dropdown item labels
            '& .ql-picker-label[data-value="h1"]::before, & .ql-picker-item[data-value="h1"]::before': {
              // Header 1
              content: '"Header 1"'
            },
            '& .ql-picker-label[data-value="h2"]::before, & .ql-picker-item[data-value="h2"]::before': {
              // Header 2
              content: '"Header 2"'
            },
            '& .ql-picker-label[data-value="h3"]::before, & .ql-picker-item[data-value="h3"]::before': {
              // Header 3
              content: '"Header 3"'
            },
            '& .ql-picker-label[data-value="h4"]::before, & .ql-picker-item[data-value="h4"]::before': {
              // Header 4
              content: '"Header 4"'
            },
            '& .ql-picker-label[data-value="h5"]::before, & .ql-picker-item[data-value="h5"]::before': {
              // Header 5
              content: '"Header 5"'
            },
            '& .ql-picker-label[data-value="h6"]::before, & .ql-picker-item[data-value="h6"]::before': {
              // Header 6
              content: '"Header 6"'
            },
            '& .ql-picker-label[data-value="body1"]::before, & .ql-picker-item[data-value="body1"]::before': {
              // Body 1
              content: '"Body 1"'
            },
            '& .ql-picker-label[data-value="body2"]::before, & .ql-picker-item[data-value="body2"]::before': {
              // Body 2
              content: '"Body 2"'
            },
            '& .ql-picker-label[data-value="body3"]::before, & .ql-picker-item[data-value="body3"]::before': {
              // Body 3
              content: '"Body 3"'
            },
            '& .ql-picker-label[data-value="caption"]::before, & .ql-picker-item[data-value="caption"]::before': {
              // Caption
              content: '"Caption"'
            }
          }
        }
      },
      // End en_GB translations
      // Start ar translations
      '&.ql-locale-ar': {
        '& .ql-snow': {
          '& .ql-picker.ql-header': {
            // Default Quill Toolbar - Header toolbar dropdown item labels
            '& .ql-picker-label::before, & .ql-picker-item::before': {
              // Normal
              content: '"عادي"'
            },
            // Custom Toolbar - Custom Header toolbar dropdown item labels
            '& .ql-picker-label[data-value="h1"]::before, & .ql-picker-item[data-value="h1"]::before': {
              // Header 1
              content: '"العنوان 1"'
            },
            '& .ql-picker-label[data-value="h2"]::before, & .ql-picker-item[data-value="h2"]::before': {
              // Header 2
              content: '"العنوان 2"'
            },
            '& .ql-picker-label[data-value="h3"]::before, & .ql-picker-item[data-value="h3"]::before': {
              // Header 3
              content: '"العنوان 3"'
            },
            '& .ql-picker-label[data-value="h4"]::before, & .ql-picker-item[data-value="h4"]::before': {
              // Header 4
              content: '"العنوان 4"'
            },
            '& .ql-picker-label[data-value="h5"]::before, & .ql-picker-item[data-value="h5"]::before': {
              // Header 5
              content: '"العنوان 5"'
            },
            '& .ql-picker-label[data-value="h6"]::before, & .ql-picker-item[data-value="h6"]::before': {
              // Header 6
              content: '"العنوان 6"'
            },
            '& .ql-picker-label[data-value="body1"]::before, & .ql-picker-item[data-value="body1"]::before': {
              // Body 1
              content: '"النص الأساسي 1"'
            },
            '& .ql-picker-label[data-value="body2"]::before, & .ql-picker-item[data-value="body2"]::before': {
              // Body 2
              content: '"النص الأساسي 2"'
            },
            '& .ql-picker-label[data-value="body3"]::before, & .ql-picker-item[data-value="body3"]::before': {
              // Body 3
              content: '"النص الأساسي 3"'
            },
            '& .ql-picker-label[data-value="caption"]::before, & .ql-picker-item[data-value="caption"]::before': {
              // Caption
              content: '"تسمية توضيحية"'
            }
          }
        }
      },
      // End ar translations
      // Start es translations
      '&.ql-locale-es': {
        '& .ql-snow': {
          '& .ql-picker.ql-header': {
            // Default Quill Toolbar - Header toolbar dropdown item labels
            '& .ql-picker-label::before, & .ql-picker-item::before': {
              // Normal
              content: '"Normal"'
            },
            // Custom Toolbar - Custom Header toolbar dropdown item labels
            '& .ql-picker-label[data-value="h1"]::before, & .ql-picker-item[data-value="h1"]::before': {
              // Header 1
              content: '"Encabezado 1"'
            },
            '& .ql-picker-label[data-value="h2"]::before, & .ql-picker-item[data-value="h2"]::before': {
              // Header 2
              content: '"Encabezado 2"'
            },
            '& .ql-picker-label[data-value="h3"]::before, & .ql-picker-item[data-value="h3"]::before': {
              // Header 3
              content: '"Encabezado 3"'
            },
            '& .ql-picker-label[data-value="h4"]::before, & .ql-picker-item[data-value="h4"]::before': {
              // Header 4
              content: '"Encabezado 4"'
            },
            '& .ql-picker-label[data-value="h5"]::before, & .ql-picker-item[data-value="h5"]::before': {
              // Header 5
              content: '"Encabezado 5"'
            },
            '& .ql-picker-label[data-value="h6"]::before, & .ql-picker-item[data-value="h6"]::before': {
              // Header 6
              content: '"Encabezado 6"'
            },
            '& .ql-picker-label[data-value="body1"]::before, & .ql-picker-item[data-value="body1"]::before': {
              // Body 1
              content: '"Texto 1"'
            },
            '& .ql-picker-label[data-value="body2"]::before, & .ql-picker-item[data-value="body2"]::before': {
              // Body 2
              content: '"Texto 2"'
            },
            '& .ql-picker-label[data-value="body3"]::before, & .ql-picker-item[data-value="body3"]::before': {
              // Body 3
              content: '"Texto 3"'
            },
            '& .ql-picker-label[data-value="caption"]::before, & .ql-picker-item[data-value="caption"]::before': {
              // Caption
              content: '"Leyenda"'
            }
          }
        }
      },
      // End es translations
      // Start fr translations
      '&.ql-locale-fr': {
        '& .ql-snow': {
          '& .ql-picker.ql-header': {
            // Default Quill Toolbar - Header toolbar dropdown item labels
            '& .ql-picker-label::before, & .ql-picker-item::before': {
              // Normal
              content: '"Normal"'
            },
            // Custom Toolbar - Custom Header toolbar dropdown item labels
            '& .ql-picker-label[data-value="h1"]::before, & .ql-picker-item[data-value="h1"]::before': {
              // Header 1
              content: '"En-tête 1"'
            },
            '& .ql-picker-label[data-value="h2"]::before, & .ql-picker-item[data-value="h2"]::before': {
              // Header 2
              content: '"En-tête 2"'
            },
            '& .ql-picker-label[data-value="h3"]::before, & .ql-picker-item[data-value="h3"]::before': {
              // Header 3
              content: '"En-tête 3"'
            },
            '& .ql-picker-label[data-value="h4"]::before, & .ql-picker-item[data-value="h4"]::before': {
              // Header 4
              content: '"En-tête 4"'
            },
            '& .ql-picker-label[data-value="h5"]::before, & .ql-picker-item[data-value="h5"]::before': {
              // Header 5
              content: '"En-tête 5"'
            },
            '& .ql-picker-label[data-value="h6"]::before, & .ql-picker-item[data-value="h6"]::before': {
              // Header 6
              content: '"En-tête 6"'
            },
            '& .ql-picker-label[data-value="body1"]::before, & .ql-picker-item[data-value="body1"]::before': {
              // Body 1
              content: '"Corps 1"'
            },
            '& .ql-picker-label[data-value="body2"]::before, & .ql-picker-item[data-value="body2"]::before': {
              // Body 2
              content: '"Corps 2"'
            },
            '& .ql-picker-label[data-value="body3"]::before, & .ql-picker-item[data-value="body3"]::before': {
              // Body 3
              content: '"Corps 3"'
            },
            '& .ql-picker-label[data-value="caption"]::before, & .ql-picker-item[data-value="caption"]::before': {
              // Caption
              content: '"Légende"'
            }
          }
        }
      },
      // End fr translations
      // Start fr_CA translations
      '&.ql-locale-fr-CA': {
        '& .ql-snow': {
          '& .ql-picker.ql-header': {
            // Default Quill Toolbar - Header toolbar dropdown item labels
            '& .ql-picker-label::before, & .ql-picker-item::before': {
              // Normal
              content: '"Normal"'
            },
            // Custom Toolbar - Custom Header toolbar dropdown item labels
            '& .ql-picker-label[data-value="h1"]::before, & .ql-picker-item[data-value="h1"]::before': {
              // Header 1
              content: '"En-tête 1"'
            },
            '& .ql-picker-label[data-value="h2"]::before, & .ql-picker-item[data-value="h2"]::before': {
              // Header 2
              content: '"En-tête 2"'
            },
            '& .ql-picker-label[data-value="h3"]::before, & .ql-picker-item[data-value="h3"]::before': {
              // Header 3
              content: '"En-tête 3"'
            },
            '& .ql-picker-label[data-value="h4"]::before, & .ql-picker-item[data-value="h4"]::before': {
              // Header 4
              content: '"En-tête 4"'
            },
            '& .ql-picker-label[data-value="h5"]::before, & .ql-picker-item[data-value="h5"]::before': {
              // Header 5
              content: '"En-tête 5"'
            },
            '& .ql-picker-label[data-value="h6"]::before, & .ql-picker-item[data-value="h6"]::before': {
              // Header 6
              content: '"En-tête 6"'
            },
            '& .ql-picker-label[data-value="body1"]::before, & .ql-picker-item[data-value="body1"]::before': {
              // Body 1
              content: '"Corps 1"'
            },
            '& .ql-picker-label[data-value="body2"]::before, & .ql-picker-item[data-value="body2"]::before': {
              // Body 2
              content: '"Corps 2"'
            },
            '& .ql-picker-label[data-value="body3"]::before, & .ql-picker-item[data-value="body3"]::before': {
              // Body 3
              content: '"Corps 3"'
            },
            '& .ql-picker-label[data-value="caption"]::before, & .ql-picker-item[data-value="caption"]::before': {
              // Caption
              content: '"Légende"'
            }
          }
        }
      }
      // End fr_CA translations
    }
  };
}, {
  index: 0
});
var _default = exports.default = editorStyles;